import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, Sparkles, CheckCircle2, Circle, AlertCircle, FileSignature, MessageSquare, DollarSign, Users, Activity, FileText, Edit2 } from 'lucide-react';
import { Link } from 'react-router-dom';
export function DealDetailPage() {
  const [activeTab, setActiveTab] = useState('Summary');
  const tabs = ['Summary', 'Terms', 'Messages', 'Contract', 'Payments', 'Lineup', 'Activity'];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-6xl mx-auto" data-id="element-2862">
      {/* Header */}
      <div className="mb-6" data-id="element-2863">
        <Link to="/app/deals" className="inline-flex items-center gap-2 text-sm text-textMuted hover:text-textMain transition-colors mb-4" data-id="element-2864">
          <ChevronLeft className="w-4 h-4" data-id="element-2865" /> Back to Deals
        </Link>
        <div className="flex justify-between items-start" data-id="element-2866">
          <div data-id="element-2867">
            <div className="flex items-center gap-3 mb-1" data-id="element-2868">
              <h2 className="text-2xl font-bold" data-id="element-2869">The Empty Bottle</h2>
              <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded font-medium" data-id="element-2870">
                Offer
              </span>
            </div>
            <p className="text-textMuted" data-id="element-2871">Jun 12, 2026 • Chicago, IL</p>
          </div>
          <div className="flex items-center gap-4" data-id="element-2872">
            <div className="text-right" data-id="element-2873">
              <div className="text-sm text-textMuted" data-id="element-2874">Deal Value</div>
              <div className="text-xl font-bold text-primary" data-id="element-2875">$1,500</div>
            </div>
            <div className="w-10 h-10 rounded-full bg-surface border border-border flex items-center justify-center font-bold text-textMuted" data-id="element-2876">
              M
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-6 border-b border-border mb-6 overflow-x-auto" data-id="element-2877">
        {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-sm font-medium whitespace-nowrap transition-colors ${activeTab === tab ? 'text-primary border-b-2 border-primary' : 'text-textMuted hover:text-textMain'}`} data-id="element-2878">
            {tab}
          </button>)}
      </div>

      {/* Tab Content */}
      <div className="pb-12" data-id="element-2879">
        {activeTab === 'Summary' && <div className="space-y-6" data-id="element-2880">
            {/* AI Banner */}
            <div className="bg-primary/10 border border-primary/20 rounded-xl p-4 flex items-start gap-3" data-id="element-2881">
              <Sparkles className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-2882" />
              <div className="flex-1" data-id="element-2883">
                <h3 className="text-sm font-medium text-primary mb-1" data-id="element-2884">
                  AI Recommendation
                </h3>
                <p className="text-sm text-textMuted mb-3" data-id="element-2885">
                  This offer is $500 below your target fee of $2,000. Consider
                  countering to meet your policy.
                </p>
                <div className="flex gap-2" data-id="element-2886">
                  <button className="px-3 py-1.5 bg-primary text-background text-sm font-medium rounded hover:bg-primaryHover transition-colors" data-id="element-2887">
                    Draft Counter ($2,000)
                  </button>
                  <button className="px-3 py-1.5 bg-surface border border-border text-sm font-medium rounded hover:bg-surfaceHover transition-colors" data-id="element-2888">
                    Accept Offer
                  </button>
                  <button className="px-3 py-1.5 bg-surface border border-border text-sm font-medium rounded hover:bg-surfaceHover transition-colors text-red-500 hover:text-red-400 hover:border-red-500/30" data-id="element-2889">
                    Reject
                  </button>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2890">
              {/* Readiness Checklist */}
              <div className="bg-surface border border-border rounded-xl p-5" data-id="element-2891">
                <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-4" data-id="element-2892">
                  Readiness
                </h3>
                <div className="space-y-3" data-id="element-2893">
                  <div className="flex items-center justify-between text-sm" data-id="element-2894">
                    <span className="flex items-center gap-2" data-id="element-2895">
                      <Circle className="w-4 h-4 text-textMuted" data-id="element-2896" /> Contract
                    </span>
                    <span className="text-textMuted text-xs" data-id="element-2897">Pending</span>
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-2898">
                    <span className="flex items-center gap-2" data-id="element-2899">
                      <Circle className="w-4 h-4 text-textMuted" data-id="element-2900" /> Deposit
                    </span>
                    <span className="text-textMuted text-xs" data-id="element-2901">
                      Not requested
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-2902">
                    <span className="flex items-center gap-2" data-id="element-2903">
                      <AlertCircle className="w-4 h-4 text-amber-500" data-id="element-2904" /> Lineup
                    </span>
                    <span className="text-amber-500 text-xs" data-id="element-2905">
                      3/4 Confirmed
                    </span>
                  </div>
                  <div className="flex items-center justify-between text-sm" data-id="element-2906">
                    <span className="flex items-center gap-2" data-id="element-2907">
                      <Circle className="w-4 h-4 text-textMuted" data-id="element-2908" /> Advance
                    </span>
                    <span className="text-textMuted text-xs" data-id="element-2909">Not started</span>
                  </div>
                </div>
              </div>

              {/* Blocking Issues */}
              <div className="bg-surface border border-border rounded-xl p-5" data-id="element-2910">
                <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-4" data-id="element-2911">
                  Blocking Issues
                </h3>
                <div className="space-y-3" data-id="element-2912">
                  <div className="p-3 bg-red-500/10 border border-red-500/20 rounded-lg flex items-start gap-2" data-id="element-2913">
                    <AlertCircle className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-2914" />
                    <div data-id="element-2915">
                      <div className="text-sm font-medium text-red-500" data-id="element-2916">
                        Below target fee
                      </div>
                      <div className="text-xs text-red-500/70" data-id="element-2917">
                        Offer is $1,500 (Target: $2,000)
                      </div>
                    </div>
                  </div>
                  <div className="p-3 bg-amber-500/10 border border-amber-500/20 rounded-lg flex items-start gap-2" data-id="element-2918">
                    <AlertCircle className="w-4 h-4 text-amber-500 shrink-0 mt-0.5" data-id="element-2919" />
                    <div data-id="element-2920">
                      <div className="text-sm font-medium text-amber-500" data-id="element-2921">
                        Lineup conflict
                      </div>
                      <div className="text-xs text-amber-500/70" data-id="element-2922">
                        Tom (Drums) has a conflict on Jun 12
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Next Action */}
              <div className="bg-surface border border-border rounded-xl p-5 flex flex-col" data-id="element-2923">
                <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-4" data-id="element-2924">
                  Next Best Action
                </h3>
                <div className="flex-1 flex flex-col items-center justify-center text-center p-4 border border-dashed border-border rounded-lg" data-id="element-2925">
                  <MessageSquare className="w-8 h-8 text-primary mb-2" data-id="element-2926" />
                  <div className="text-sm font-medium mb-1" data-id="element-2927">
                    Send Counter-Offer
                  </div>
                  <div className="text-xs text-textMuted mb-3" data-id="element-2928">
                    Address the fee gap before generating a contract.
                  </div>
                  <button className="px-4 py-2 bg-primary/10 text-primary text-sm font-medium rounded hover:bg-primary/20 transition-colors w-full" data-id="element-2929">
                    Draft Message
                  </button>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'Terms' && <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2930">
            {[{
          title: 'Compensation',
          value: '$1,500 guarantee vs 70% door after expenses',
          status: 'warning'
        }, {
          title: 'Lodging',
          value: 'Not provided',
          status: 'warning'
        }, {
          title: 'Rider',
          value: 'Standard rider accepted',
          status: 'good'
        }, {
          title: 'Deposit',
          value: '50% ($750) due 14 days before',
          status: 'good'
        }, {
          title: 'Special Conditions',
          value: 'None',
          status: 'neutral'
        }, {
          title: 'Radius Clause',
          value: '60 miles / 30 days',
          status: 'good'
        }].map((term, i) => <div key={i} className="bg-surface border border-border rounded-xl p-5 flex items-start justify-between group" data-id="element-2931">
                <div data-id="element-2932">
                  <div className="text-sm text-textMuted mb-1 flex items-center gap-2" data-id="element-2933">
                    {term.title}
                    {term.status === 'good' && <CheckCircle2 className="w-3.5 h-3.5 text-green-500" data-id="element-2934" />}
                    {term.status === 'warning' && <AlertCircle className="w-3.5 h-3.5 text-amber-500" data-id="element-2935" />}
                  </div>
                  <div className="font-medium" data-id="element-2936">{term.value}</div>
                </div>
                <button className="p-1.5 text-textMuted hover:text-textMain hover:bg-surfaceHover rounded opacity-0 group-hover:opacity-100 transition-all" data-id="element-2937">
                  <Edit2 className="w-4 h-4" data-id="element-2938" />
                </button>
              </div>)}
          </div>}

        {activeTab === 'Messages' && <div className="bg-surface border border-border rounded-xl overflow-hidden flex flex-col h-[500px]" data-id="element-2939">
            <div className="flex-1 overflow-y-auto p-6 space-y-6" data-id="element-2940">
              <div className="flex gap-4" data-id="element-2941">
                <div className="w-8 h-8 rounded-full bg-surfaceHover border border-border flex items-center justify-center text-sm font-bold shrink-0" data-id="element-2942">
                  EB
                </div>
                <div className="flex-1" data-id="element-2943">
                  <div className="flex justify-between items-baseline mb-2" data-id="element-2944">
                    <span className="font-medium" data-id="element-2945">The Empty Bottle</span>
                    <span className="text-xs text-textMuted" data-id="element-2946">
                      Today, 10:24 AM
                    </span>
                  </div>
                  <div className="text-sm text-textMuted leading-relaxed space-y-4" data-id="element-2947">
                    <p data-id="element-2948">Hey Mark,</p>
                    <p data-id="element-2949">
                      Thanks for reaching out. We'd love to have The Wildwoods
                      back. June 12th is currently open on our calendar.
                    </p>
                    <p data-id="element-2950">
                      We can offer a $1,500 guarantee vs 70% of door after
                      expenses. Let me know if that works for you and I'll send
                      over the hold details.
                    </p>
                    <p data-id="element-2951">
                      Best,
                      <br data-id="element-2952" />
                      Dan
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-4 opacity-60" data-id="element-2953">
                <div className="w-8 h-8 rounded-full bg-primary/20 border border-primary/30 flex items-center justify-center text-sm font-bold text-primary shrink-0" data-id="element-2954">
                  M
                </div>
                <div className="flex-1" data-id="element-2955">
                  <div className="flex justify-between items-baseline mb-2" data-id="element-2956">
                    <span className="font-medium" data-id="element-2957">You</span>
                    <span className="text-xs text-textMuted" data-id="element-2958">
                      Yesterday, 2:15 PM
                    </span>
                  </div>
                  <div className="text-sm text-textMuted leading-relaxed" data-id="element-2959">
                    <p data-id="element-2960">Hi Dan,</p>
                    <p data-id="element-2961">
                      The Wildwoods are routing through Chicago mid-June. We're
                      looking at June 12th or 13th. Are either of those dates
                      open?
                    </p>
                    <p data-id="element-2962">Mark</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-4 border-t border-border bg-background/50" data-id="element-2963">
              <div className="bg-surface border border-border rounded-lg p-3" data-id="element-2964">
                <textarea placeholder="Reply to The Empty Bottle..." className="w-full bg-transparent text-sm focus:outline-none resize-none h-20 text-textMain placeholder:text-textMuted" data-id="element-2965"></textarea>
                <div className="flex justify-between items-center mt-2 pt-2 border-t border-border" data-id="element-2966">
                  <button className="text-xs text-primary hover:text-primaryHover flex items-center gap-1" data-id="element-2967">
                    <Sparkles className="w-3 h-3" data-id="element-2968" /> Draft with AI
                  </button>
                  <button className="px-4 py-1.5 bg-textMain text-background text-sm font-medium rounded hover:bg-textMuted transition-colors" data-id="element-2969">
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'Contract' && <div className="bg-surface border border-border rounded-xl p-8 text-center" data-id="element-2970">
            <FileSignature className="w-12 h-12 text-textMuted mx-auto mb-4" data-id="element-2971" />
            <h3 className="text-lg font-medium mb-2" data-id="element-2972">
              Contract Not Yet Generated
            </h3>
            <p className="text-sm text-textMuted mb-6 max-w-md mx-auto" data-id="element-2973">
              The deal terms are currently in negotiation. Once terms are agreed
              upon, you can generate a contract from a template.
            </p>
            <div className="flex items-center justify-center gap-3" data-id="element-2974">
              <select className="px-3 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-2975">
                <option data-id="element-2976">Standard Performance Contract</option>
                <option data-id="element-2977">Festival Contract</option>
              </select>
              <button className="px-4 py-2 bg-primary text-background text-sm font-medium rounded-lg hover:bg-primaryHover transition-colors" data-id="element-2978">
                Generate Contract
              </button>
            </div>
          </div>}

        {activeTab === 'Payments' && <div className="bg-surface border border-border rounded-xl p-8 text-center" data-id="element-2979">
            <DollarSign className="w-12 h-12 text-textMuted mx-auto mb-4" data-id="element-2980" />
            <h3 className="text-lg font-medium mb-2" data-id="element-2981">No Active Payments</h3>
            <p className="text-sm text-textMuted mb-6 max-w-md mx-auto" data-id="element-2982">
              Payments and deposits will be tracked here once the deal is
              confirmed and a contract is signed.
            </p>
            <div className="flex justify-center" data-id="element-2983">
              <div className="flex items-center gap-2 text-sm text-textMuted opacity-50" data-id="element-2984">
                <div className="w-6 h-6 rounded-full border-2 border-border flex items-center justify-center text-xs" data-id="element-2985">
                  1
                </div>
                <span data-id="element-2986">Deposit Requested</span>
                <div className="w-8 h-px bg-border mx-2" data-id="element-2987"></div>
                <div className="w-6 h-6 rounded-full border-2 border-border flex items-center justify-center text-xs" data-id="element-2988">
                  2
                </div>
                <span data-id="element-2989">Deposit Received</span>
                <div className="w-8 h-px bg-border mx-2" data-id="element-2990"></div>
                <div className="w-6 h-6 rounded-full border-2 border-border flex items-center justify-center text-xs" data-id="element-2991">
                  3
                </div>
                <span data-id="element-2992">Settlement</span>
              </div>
            </div>
          </div>}

        {activeTab === 'Lineup' && <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-2993">
            <div className="p-4 border-b border-border bg-amber-500/10 flex items-start gap-3" data-id="element-2994">
              <AlertCircle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-2995" />
              <div data-id="element-2996">
                <h4 className="text-sm font-medium text-amber-500 mb-1" data-id="element-2997">
                  Lineup Conflict Detected
                </h4>
                <p className="text-xs text-amber-500/80" data-id="element-2998">
                  Tom Rivera (Drums) has a conflict on June 12. You may need to
                  find a substitute before confirming this date.
                </p>
              </div>
            </div>
            <table className="w-full text-sm text-left" data-id="element-2999">
              <thead className="bg-background border-b border-border text-textMuted" data-id="element-3000">
                <tr data-id="element-3001">
                  <th className="px-6 py-3 font-medium" data-id="element-3002">Member</th>
                  <th className="px-6 py-3 font-medium" data-id="element-3003">Role</th>
                  <th className="px-6 py-3 font-medium" data-id="element-3004">Status for Jun 12</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-3005">
                <tr data-id="element-3006">
                  <td className="px-6 py-4 font-medium" data-id="element-3007">Mark Thompson</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3008">Guitar, Vocals</td>
                  <td className="px-6 py-4" data-id="element-3009">
                    <span className="flex items-center gap-1.5 text-green-500" data-id="element-3010">
                      <CheckCircle2 className="w-4 h-4" data-id="element-3011" /> Available
                    </span>
                  </td>
                </tr>
                <tr data-id="element-3012">
                  <td className="px-6 py-4 font-medium" data-id="element-3013">Sarah Chen</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3014">Bass</td>
                  <td className="px-6 py-4" data-id="element-3015">
                    <span className="flex items-center gap-1.5 text-green-500" data-id="element-3016">
                      <CheckCircle2 className="w-4 h-4" data-id="element-3017" /> Available
                    </span>
                  </td>
                </tr>
                <tr className="bg-red-500/[0.02]" data-id="element-3018">
                  <td className="px-6 py-4 font-medium" data-id="element-3019">Tom Rivera</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3020">Drums</td>
                  <td className="px-6 py-4" data-id="element-3021">
                    <span className="flex items-center gap-1.5 text-red-500" data-id="element-3022">
                      <AlertCircle className="w-4 h-4" data-id="element-3023" /> Conflict
                    </span>
                  </td>
                </tr>
                <tr data-id="element-3024">
                  <td className="px-6 py-4 font-medium" data-id="element-3025">Lisa Park</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3026">Keys</td>
                  <td className="px-6 py-4" data-id="element-3027">
                    <span className="flex items-center gap-1.5 text-green-500" data-id="element-3028">
                      <CheckCircle2 className="w-4 h-4" data-id="element-3029" /> Available
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>}

        {activeTab === 'Activity' && <div className="bg-surface border border-border rounded-xl p-6" data-id="element-3030">
            <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-border before:to-transparent" data-id="element-3031">
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-3032">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-border bg-surface shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow text-primary" data-id="element-3033">
                  <MessageSquare className="w-4 h-4" data-id="element-3034" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-border bg-background shadow" data-id="element-3035">
                  <div className="flex items-center justify-between mb-1" data-id="element-3036">
                    <div className="font-bold text-sm" data-id="element-3037">Offer Received</div>
                    <div className="text-xs text-textMuted" data-id="element-3038">
                      Today, 10:24 AM
                    </div>
                  </div>
                  <div className="text-sm text-textMuted" data-id="element-3039">
                    The Empty Bottle offered $1,500 guarantee.
                  </div>
                </div>
              </div>

              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-3040">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-border bg-surface shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow text-primary" data-id="element-3041">
                  <Sparkles className="w-4 h-4" data-id="element-3042" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-border bg-background shadow" data-id="element-3043">
                  <div className="flex items-center justify-between mb-1" data-id="element-3044">
                    <div className="font-bold text-sm" data-id="element-3045">
                      AI Analysis Complete
                    </div>
                    <div className="text-xs text-textMuted" data-id="element-3046">
                      Today, 10:25 AM
                    </div>
                  </div>
                  <div className="text-sm text-textMuted" data-id="element-3047">
                    Identified fee gap and lineup conflict.
                  </div>
                </div>
              </div>

              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-3048">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-border bg-surface shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow text-textMuted" data-id="element-3049">
                  <Activity className="w-4 h-4" data-id="element-3050" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-border bg-background shadow" data-id="element-3051">
                  <div className="flex items-center justify-between mb-1" data-id="element-3052">
                    <div className="font-bold text-sm" data-id="element-3053">Deal Created</div>
                    <div className="text-xs text-textMuted" data-id="element-3054">
                      Yesterday, 2:15 PM
                    </div>
                  </div>
                  <div className="text-sm text-textMuted" data-id="element-3055">
                    Initial inquiry sent to venue.
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </motion.div>;
}